import { generatePath } from 'react-router';
import { paths } from '../../../common/constants/pathVariables.js';
import {
  corporatePhoneMsg,
  costCenterMsg,
  extensionNumberMsg,
  idNumberMsg,
  numberOfTheBillingAccountMsg,
  pukCodeMsg,
  referenceMsg,
  simCardNumberMsg,
  t,
} from '../../../common/i18n/index.js';
import { getSubscriptionUrlId } from '../../../common/utils/subscriptionUtils.js';
import { SearchResultRow } from '../SearchResultRow.js';
import { HeaderSectionContent, SectionContent } from '../SectionContent.js';
import { getResultObjectWithHighlightedValues } from '../highlightFunctions.js';
import type { SubscriptionHeader } from '../../../generated/api/subscriptionHeader.js';
import type { SearchResultBaseProps } from '../SearchResultRow.js';

export interface VoiceSubscriptionProps extends SearchResultBaseProps {
  subscription: SubscriptionHeader;
}

export const VoiceSubscription = ({ subscription, matchedFields, searchTerms, ...rest }: VoiceSubscriptionProps) => {
  const {
    subscriptionName,
    subscriptionContactName,
    subscriptionPurposeOfUse,
    subscriptionUserFriendlyId,
    billingAccountDisplayId,
    simCardNumber,
    costCenter,
    subscriptionReference,
    corporateNumber,
    extensionNumber,
    subscriptionDisplayId,
    puk1,
  } = getResultObjectWithHighlightedValues(subscription, matchedFields, searchTerms);
  return (
    <SearchResultRow
      icon="sim"
      upperSection={
        <HeaderSectionContent
          left={subscriptionContactName || subscriptionPurposeOfUse || ''}
          right={subscriptionUserFriendlyId}
        />
      }
      lowerSection={
        <SectionContent
          left={subscriptionName || ''}
          right={
            puk1 && (
              <>
                {t.K5TL(pukCodeMsg)}: {puk1}
              </>
            )
          }
        />
      }
      additionalHighlightableFields={[
        { title: t.VLQ3(simCardNumberMsg), value: simCardNumber, key: 'simCardNumber' },
        { title: t.D9TG(corporatePhoneMsg), value: corporateNumber, key: 'corporateNumber' },
        { title: t.NO66(extensionNumberMsg), value: extensionNumber, key: 'extensionNumber' },
        { title: t.GQLW(numberOfTheBillingAccountMsg), value: billingAccountDisplayId, key: 'billingAccountDisplayId' },
        { title: t.L2OG(costCenterMsg), value: costCenter, key: 'costCenter' },
        { title: t.LVRN(referenceMsg), value: subscriptionReference, key: 'subscriptionReference' },
        { title: t.YTH3(idNumberMsg), value: subscriptionDisplayId, key: 'subscriptionDisplayId' },
      ]}
      matchedFields={matchedFields}
      linkHref={`${generatePath(paths.PS_MOBILE_SUBSCRIPTION, { subscriptionId: getSubscriptionUrlId(subscription) })}?mdmId=${subscription.accountMasterId}`}
      {...rest}
    />
  );
};
